var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.03 16.6C18.3995 16.2275 18.6078 15.7247 18.61 15.2V12.2H16.61V15.2L11.61 10.2L9.61 8.2L8.03 6.6L6.61 5.2L1.41 0L0 1.41L9.61 11.02V13.2H11.61V13.02L13.79 15.2H4.61V12.2H2.61V15.2C2.61 15.7304 2.82071 16.2391 3.19579 16.6142C3.57086 16.9893 4.07957 17.2 4.61 17.2H15.79L18.39 19.8L19.81 18.39L18.03 16.6Z",
    fill: "#FF0801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60906 5.0302V5.3402L11.6091 7.3402V5.0302L14.1991 7.6102L15.6091 6.2002L10.6091 1.2002L8.03906 3.7702L9.45906 5.1802L9.60906 5.0302Z",
    fill: "#FF0801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorUpload);
export default __webpack_public_path__ + "static/media/errorUpload.b95375f7ed810375c26763c6d3dfdfce.svg";
export { ForwardRef as ReactComponent };